import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailers-select_quantity_dropdown-click';

/**
 * Fires when retailer selects a quantity using the dropdown on the PDP Picker.

Parameter: Value selected
 */
export function trackRetailersSelectQuantityDropdownClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { customParameterToken },
  });
}
